export default __webpack_public_path__ + "static/media/motivation.3b71d71a.mp4";